import { createContext } from 'react';
import type { IResponse } from '../gql/get-user';

export const LoggedInUserContext = createContext<IResponse | null>(null);
export const LoggedInUserProvider = LoggedInUserContext.Provider;
